<template>
    <div>
        <b-row v-if="app">
            <b-col cols="12" md="6" v-if="app.owner === null">
                <b-card>
                    <b-row>
                        <b-col cols="12" class="mb-2">
                            <protokol-settings-dropdown size="sm" class="float-right">
                                <b-dropdown-item-button v-if="canDownload" @click="download"> {{ $t('download') }} </b-dropdown-item-button>
                                <b-dropdown-item-button @click="refreshPermissions"> {{ $t('refreshPermissions') }} </b-dropdown-item-button>
                                <b-dropdown-item-button @click="generateSecret"> {{ $t('generateNewSecret') }} </b-dropdown-item-button>
                                <b-dropdown-item-button v-if="canRemove" @click="remove"> {{ $t('delete') }} </b-dropdown-item-button>
                            </protokol-settings-dropdown>
                        </b-col>
                        <b-col cols="12" md="4" class="mb-2">
                            <b-input-group-append>
                                <b-button @click="openWebIDE" variant="success">Web IDE</b-button> 
                                <b-dropdown :text="ideVersion">
                                    <b-dropdown-item v-for="version in availableVersion" :key="version" @click="previewVersion = version"> {{ version }} </b-dropdown-item>
                                    <b-dropdown-divider />
                                    <b-dropdown-item @click="forkModal = true" v-if="app.dev_version != ''"> {{ $t('fork') }} </b-dropdown-item>
                                    <b-dropdown-item @click="removeVersion()" v-if="app.dev_version != ''"> {{ $t('remove') }} </b-dropdown-item>
                                </b-dropdown>
                            </b-input-group-append>
                        </b-col>
                        <b-col cols="4" md="4"  class="mb-2">
                            <b-dropdown
                                :text="'Dev: ' + devVersion"
                                >
                                <b-dropdown-item v-for="version in availableVersion" :key="version" @click="publishDevVersion(version)">{{ version }}</b-dropdown-item>
                                <b-dropdown-divider />
                                <b-dropdown-item @click="publishDevVersion('')" v-if="app.dev_version != ''"> {{ $t('deactivate') }} </b-dropdown-item>
                            </b-dropdown>
                        </b-col>

                        <b-col cols="12" md="4">
                            <b-dropdown
                                :text="'Live: ' + liveVersion"
                                >
                                <b-dropdown-item v-for="version in availableVersion" :key="version" @click="publishLiveVersion(version)">{{ version }}</b-dropdown-item>
                                <b-dropdown-divider />
                                <b-dropdown-item @click="publishLiveVersion('')" v-if="app.public_version != ''"> {{ $t('unpublish') }} </b-dropdown-item>
                            </b-dropdown>
                        </b-col>

                        <b-col cols="12">
                            <b-form-group
                                :label="this.$t('version')"
                                :description="$t('changingAppVersionCanBreakYouApp')"
                                label-for="version"
                                :label-cols="12"
                                v-if="app.external_id === null"
                                :horizontal="false">
                                <v-select v-model="app.app_version" :options="[4,5]" />

                                <small class="text-danger" v-if="isVersionDeprecated"> {{ $t('thisAppVersionIsDeprecated') }} </small>
                            </b-form-group>
                        </b-col>

                        <b-col cols="12">
                            <b-form-group
                                :label="this.$t('upload')"
                                label-for="upload"
                                :description="$t('uploadAppSettingsDescription')"
                                :label-cols="12"
                                v-if="app.external_id === null"
                                :horizontal="false">
                                <b-input-group>
                                    <b-file v-model="uploadFile"  />

                                    <b-input-append><b-button variant="success" @click="upload"> {{ $t('upload') }} </b-button></b-input-append>
                                </b-input-group>
                            </b-form-group>
                        </b-col>

                        <b-col cols="12"><b-button @click="save" variant="success">{{ $t('save') }}</b-button></b-col>
                    </b-row>
                </b-card>
            </b-col>
            <b-col cols="12" md="6">
                <b-card>
                    <b-form-group
                        label="Hostnames"
                    >
                        <b-row>
                            <b-col cols="12" md="10">
                            <b-input-group-append>
                                <b-input v-model="parseHostname" />
                                <b-dropdown :text="defaultDomain">
                                    <b-dropdown-item v-for="d in availableDomains" @click="domain = d" :key="d">{{ d }}</b-dropdown-item>
                                    <!-- <b-dropdown-item @click="domain = 'custom'">{{ $t('custom') }}</b-dropdown-item> -->
                                </b-dropdown>
                            </b-input-group-append>
                            </b-col>

                            <b-col cols="12" md="2">
                                <b-button variant="success" @click="addHostname" :disabled="disableDomainAdd">{{ $t('add') }}</b-button>
                            </b-col>
                        </b-row>
                        
                        <div class="mt-3">
                            <b-badge class="mr-1" v-if="app.basehostname" @click="preview(stageHostname)">{{ stageHostname }}</b-badge>
                            <b-badge class="mr-1" @click="preview(app.basehostname)">{{ app.basehostname }}</b-badge>
                            <b-badge v-for="host in app.hostnames" :key="host" class="mr-1" @click="preview(host)"> {{ host }} <i class="fa fa-close" v-if="canShowRemoveHostname(host)" @click="removeHostname(host)"></i></b-badge>
                        </div>
                    </b-form-group>
                </b-card>
            </b-col>

            <b-col cols="12" v-if="settings && appConfig && appConfig.appSettings">
                <b-row>
                    <b-col cols="2">
                        <protokol-settings-dropdown size="sm" :text="currentEnv">
                            <b-dropdown-item-button @click="currentEnv = 'dev'"> Dev </b-dropdown-item-button>
                            <b-dropdown-item-button @click="currentEnv = 'live'" > Live </b-dropdown-item-button>
                        </protokol-settings-dropdown>
                    </b-col>

                    <b-col cols="12" class="mt-2">
                        <b-card>
                            <PowerApp :app="app" :entrypoint="appConfig.appSettings" :dist="settings.dist" noRouter @save="saveAppSettings" :config="config" :key="currentEnv"/>
                        </b-card>
                    </b-col>
                </b-row>
                </b-col>

            <main-dialog v-model="forkModal" :ok-title="$t('fork')" @ok="forkVersion">
                <b-form-group
                    :label="$t('version')"
                >
                    <b-input v-model="previewVersion" disabled></b-input>
                </b-form-group>

                <b-form-group
                    :label="$t('newVersion')"
                >
                    <b-input v-model="forkTo"></b-input>
                </b-form-group>
            </main-dialog>
    </b-row>
    </div>
</template>
<script>
import Labeli18n from '../../components/form/Texti18n'
import VSelect from "vue-select"
import PowerApp from '../apps/PowerAppV4'
import { get } from 'lodash'

export default {
    name: 'List',
    components: { 
        Labeli18n,
        VSelect,
        PowerApp
    },
    data: function() {
        return {
            app: null,
            hostname: '',
            ideVersion: this.previewVersion,
            forkModal: false,
            forkTo: null,
            domain: null,
            uploadFile: null,
            currentEnv: 'dev'
        }
    },
    computed: {
        availableVersion() {
            return this.app.settings.map(s => {
                return s.version
            })
        },

        previewVersion: {
            get() {
                return this.app.dev_version
            },

            set(val) {
                this.ideVersion = val
            }
        },

        liveVersion() {
            return this.app.public_version || "not live"
        },

        devVersion() {
            return this.app.dev_version || "not active"
        },

        stageHostname() {
            let parts = this.app.basehostname.split(".")

            parts.splice(1, 0, 'stage')

            return parts.join(".")
        },

        availableDomains() {
            return this.$env.get('PUBLIC_APP_DOMAINS').split(",")
        },

        parseHostname: {
            get() {
                return this.hostname.replace(/[^a-z -]/g, '').replaceAll(' ', '');
            }, 

            set(val) {
                this.hostname = val.replace(/[^a-z -]/g, '').replaceAll(' ', '');
            }
        },

        fullHostname() {
            return `${this.hostname}.${this.defaultDomain}`
        },

        fullStageHostname() {
            return `${this.hostname}.stage.${this.defaultDomain}`
        },

        disableDomainAdd() {
            if (this.app.hostnames)
                return this.app.hostnames.length >= 6

            return false
        },

        defaultDomain: {
            get() {
                if (this.domain === null) {
                    return this.availableDomains[0]
                }

                return this.domain
            },

            set(val) {
                this.domain = val
            }
        },

        canRemove() {
            const { integrators = [] } = this.app || {}

            return integrators.indexOf("platform") !== -1
        },

        isVersionDeprecated() {
            let versions = [4]

            return versions.indexOf(this.app.app_version) !== -1
        },

        canDownload() {
            if (this.app.owner !== null) return false

            return this.$can("manage base_public_apps")
        },

        settings() {
            return this.app.settings.find(s => {
                return s.version == this.previewVersion
            })
        },

        appConfig() {
            if (this.settings && this.settings.dist && this.settings.dist['views.json'])
                return JSON.parse(this.settings.dist['views.json'] || '{}')

            return {}
        },

        config() {
            return get(this.app, `config.env.${this.currentEnv}`, {})
        },
    },
    methods: {
        addHostname() {
            // validate the hostname that is being added
            let hostnames = this.app.hostnames || []
            let f = hostnames.find(n => n == this.fullHostname)
            if (f) {
                this.$bvToast.toast(this.$t('hostnameAlreadyExists'), {
                    title: this.$t('error'),
                    variant: 'danger'
                })

                return
            }

            hostnames.push(this.fullHostname)
            hostnames.push(this.fullStageHostname)

            this.saveHostname(hostnames).then(() => {
                this.hostname = ''
                this.app.hostnames = hostnames
            })
        },

        async removeHostname(name) {
            this.app.hostnames = this.app.hostnames.filter(n => {
                return n != name
            })

            let parts = name.split('.')
            parts.splice(1, 0, 'stage')
            let stageHostname = parts.join(".")

            this.app.hostnames = this.app.hostnames.filter(n => {
                return n != stageHostname
            })

            this.saveHostname(this.app.hostnames)
        },

        canShowRemoveHostname(name) {
            let parts = name.split('.')
            if (parts[1] == "stage") {
                return false
            } 

            return true
        },

        saveHostname(hostnames) {
            return new Promise((resolve, reject) => {
                let popup = this.$loadingPopup()
                this.$http.put("/v3/system/gateway/app-service/public-app/" + this.$route.params.id +"/settings", {hostnames}).then(() => {
                    resolve()
                }).catch(err => {
                    if (err.response) {
                        if (err.response.status == 409) {
                            this.$mainDialog.msgBoxOk("Hostname is already taken")
                            return
                        }
                    }

                    this.$debugLog(err)
                    this.$mainDialog.msgBoxOk("Failed to save public app hostname.")

                    reject()
                }).finally(() => popup.hide())
            })
            
        },

        generateSecret() {
            return new Promise((resolve, reject) => {
                let popup = this.$loadingPopup()
                this.$http.post("/v3/system/gateway/app-service/public-app/" + this.$route.params.id +"/generate-secret").then(() => {
                    resolve()
                }).catch(err => {
                    this.$debugLog(err)
                    this.$bvToast.toast("Failed to generate new secret.", {
                        variant: 'danger'
                    })

                    reject()
                }).finally(() => popup.hide())
            })
            
        },

        refreshPermissions() {
            return new Promise((resolve, reject) => {
                let popup = this.$loadingPopup()
                this.$http.post("/v3/system/gateway/app-service/public-app/" + this.$route.params.id +"/refresh-permissions").then(() => {
                    resolve()
                }).catch(err => {
                    this.$debugLog(err)
                    this.$mainDialog.msgBoxOk("Failed to refresh permissions")

                    reject()
                }).finally(() => popup.hide())
            })
            
        },

        save() {
            let popup = this.$loadingPopup()
            this.$http.put(`/v3/system/gateway/app-service/public-app/${this.$route.params.id}/settings`, this.app).catch(err => {
                if (err.response) {
                    if (err.response.status == 409) {
                        this.$mainDialog.msgBoxOk("Hostname is already taken")
                        return
                    }
                }

                this.$debugLog(err)
                this.$mainDialog.msgBoxOk("Failed to save public app settings.")
            }).finally(() => popup.hide())
        },

        async remove() {
            let confirm = await this.$mainDialog.msgBoxConfirm(this.$t('areYouSure'))
            if (!confirm) return

            let popup = this.$loadingPopup()
            this.$http.delete("/v3/system/gateway/app-service/public-app/" + this.$route.params.id).then(() => {
                this.$router.push("/admin/public-app")
            }).catch(err => {
                this.$debugLog(err)
                this.$mainDialog.msgBoxOk("Failed to remove public app.")
            }).finally(() => popup.hide())
        },

        forkVersion() {
            const ver = _.cloneDeep(this.app.settings.find(s => {
                return s.version == this.previewVersion
            }))

            ver.version = this.forkTo

            this.app.settings.push(ver)

            this.save()
        },

        removeVersion() {
            this.$mainDialog.msgBoxConfirm("You are about to remove version " + this.ideVersion +". Are you sure?").then(resp => {
                if (resp) {
                    this.app.settings = this.app.settings.filter(f => {
                        return f.version !== this.ideVersion
                    })

                    this.save()
                    this.ideVersion = this.app.dev_version
                }
            })
        },

        publishDevVersion(version) {
            let message = "You are about to deploy " + version + " to dev environment. Are you sure?"
            if (version == '') {
                message = "You are about to deactivate app from dev environment, this action will also unpublish app if it is live. Are you sure?"
            }

            this.$mainDialog.msgBoxConfirm(message).then(resp => {
                if (resp) {
                    this.app.dev_version = version

                    this.save()
                }
            })

        },

        publishLiveVersion(version) {
            let message = "You are about to deploy " + version + " to live environment. Are you sure?"
            if (version == '') {
                message = "You are about to unpublish app from live environment. Are you sure?"
            }

            this.$mainDialog.msgBoxConfirm(message).then(resp => {
                if (resp) {
                    this.app.public_version = version

                    this.save()
                }
            })

        },

        preview(host) {
            window.open(`https://${host}`, '_blank')
        },

        openWebIDE() {
            const routeData = this.$router.resolve('/public-app/editor/' + this.$route.params.id + '?v=' + this.ideVersion);
            window.open(routeData.href, '_blank')
        },

        async download() {
            this.$http.post("/v3/system/gateway/app-service/public-app/download", {version: this.ideVersion, uuid: this.app.uuid}, {
                responseType: 'blob'
            }).then(resp => {
                const href = URL.createObjectURL(resp.data);

                // create "a" HTML element with href to file & click
                const link = document.createElement('a');
                link.href = href;
                link.setAttribute('download', `${this.app.name}-${this.ideVersion}.tar.gz`); //or any other extension
                document.body.appendChild(link);
                link.click();

                // clean up "a" element & remove ObjectURL
                document.body.removeChild(link);
                URL.revokeObjectURL(href);
            })
        },

        async upload() {
            let formData = new FormData();
            formData.append('app', this.uploadFile)
            formData.append('build', true)

            this.$http.post("/v3/system/gateway/app-service/public-app/upload", formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(() => {
                this.$bvToast.toast(this.$t('success'), {
                    variant: 'success'
                })
            }).catch(err => {
                this.$bvToast.toast(err.response.data.message, {
                    variant: 'danger',
                })
            })
        },

        saveAppSettings(config) {
            let popup = this.$loadingPopup()
            this.$http.put(`/v3/system/gateway/app-service/public-app/${this.$route.params.id}/config`, {
                [`config.env.${this.currentEnv}`]: config
            }).catch(err => {
                this.$debugLog(err)
                this.$bvToast.toast("Failed to save public app config.", {
                    variant: "danger"
                })
            }).finally(() => popup.hide())
        },

    },
    mounted() {
       this.$http.get(`/v3/system/gateway/app-service/public-app/${this.$route.params.id}/settings`).then(resp => {
            this.app = resp.data
            this.previewVersion = this.app.dev_version
       }).catch(err => {
           this.$debugLog(err)
           this.$mainDialog.msgBoxOk("Failed to fetch apps.")
       })
    }
}
</script>

<style scoped>
.fa-close {
    color: red
}
</style>
